// src/components/MentorDashboard/FeedbackCard.js
import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Divider, Empty } from "antd";
import { StarOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Paragraph, Text, Link } = Typography;

const FeedbackCard = ({ darkMode, ratings = [] }) => {
  const navigate = useNavigate();
  const safeRatings = ratings || [];
  const limitedRatings = safeRatings.slice(0, 2); // Only first 2

  return (
    <Card
      title={
        <span style={{ color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined }}>
          <StarOutlined style={{ marginRight: 8 }} /> Recent Feedback
        </span>
      }
      style={{
        borderRadius: 12,
        backgroundColor: darkMode ? "#1890ff33" : "#e6f7ff",
        borderColor: darkMode ? "#1890ff66" : "#91d5ff",
      }}
    >
      {limitedRatings.length > 0 ? (
        <>
          {limitedRatings.map((rating, index) => (
            <React.Fragment key={rating.learnerId || index}>
              <div style={{ marginBottom: 16 }}>
                <Paragraph style={{ color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined }}>
                  {rating.feedback}
                </Paragraph>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Text
                    strong
                    style={{ color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined }}
                  >
                    — {rating.learnerName}
                  </Text>
                  <Text>
                    {Array.from({ length: rating.rating || 0 }).map((_, i) => (
                      <StarOutlined key={i} style={{ color: "#faad14" }} />
                    ))}
                  </Text>
                </div>
              </div>
              {index < limitedRatings.length - 1 && (
                <Divider
                  style={{ margin: "12px 0", borderColor: darkMode ? "#1890ff66" : "#91d5ff" }}
                />
              )}
            </React.Fragment>
          ))}

          <Link
            style={{ marginTop: 12, display: "inline-block" }}
            onClick={() => navigate("/all-feedback", { state: { ratings: safeRatings, darkMode } })}
          >
            View All
          </Link>
        </>
      ) : (
        <Empty description="No feedback available" />
      )}
    </Card>
  );
};

FeedbackCard.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  ratings: PropTypes.arrayOf(
    PropTypes.shape({
      learnerId: PropTypes.number,
      learnerName: PropTypes.string,
      rating: PropTypes.number,
      feedback: PropTypes.string,
    })
  ),
};

FeedbackCard.defaultProps = {
  ratings: [],
};

export default FeedbackCard;
